import { OverflowMenu, OverflowMenuItem, TableCell, TableHeader } from '@carbon/react';
import cx from 'clsx';

import styles from 'theme/components/data-table/table-toolbar-cell.module.scss';

const TableToolbarCell = ({ children, className, ...props }) => (
  <TableCell {...props} className={cx(className, 'cds--table-column-menu', styles['toolbar-column'])}>
    <OverflowMenu ariaLabel="Toolbar" size="sm" flipped iconClass={styles['toolbar-icon']}>
      {children}
    </OverflowMenu>
  </TableCell>
);

TableToolbarCell.Header = function TableToolbarCellHeader() {
  return <TableHeader className={styles['toolbar-column']} />;
};

TableToolbarCell.MenuItem = OverflowMenuItem;

export default TableToolbarCell;
